import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page87() {
  useEffect(() => {
    document.title = "Маяк — Страница 86"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page85" />
        <ForwardLink href="/page87" />
      </div>

      <p style={{ textAlign: "right" }}>86.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Мне надоело смотреть на тебя, мне<br/>
        надоело смотреть на еду недельной давности<br/>
        в твоей бороде, которая смотрит мне в лицо<br/>
        так, словно "что-то замечает".<br/>
        Ты думаешь, что ты такой чертовски важный<br/>
        и могущественный, потому что ты чертов<br/>
        смотритель маяка? Ну, ты<br/>
        не капитан ни одного корабля и никогда<br/>
        им не был, ты не генерал,<br/>
        не полицейский, ты не президент,<br/>
        и <u>ты</u> <u>не</u> <u>мой</u> <u>отец</u> -- и мне<br/>
        надоело, что ты ведешь себя будто это так! Мне<br/>
        надоели твои приказы! Мне надоел<br/>
        твой смех, твой храп<br/>
        и твой проклятый пердеж. Твой проклятый<br/>
        пердеж. Черт побери твой проклятый пердеж!<br/>
        От тебя воняет мочой, от тебя воняет<br/>
        спермой, гнилым членом, свернувшейся<br/>
        крайней плотью, деревенским<br/>
        сортиром.<br/>
        И мне надоел твой запах. Мне надоело<br/>
        это! Мне это надоело, твое чертово<br/>
        пьянство. Ты проклятый, безответственный<br/>
        алкоголик, сукин сын, ублюдок-<br/>
        лжец! Вот кто ты такой: ты<br/>
        чертов пьяный засранец --<br/>
        короче -- дерьмовый лжец. Лжец!
      </p>
      <p>Длинная пауза.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        У тебя есть умение обращаться со словами, Томми.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Будь ты проклят.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Ты освобожден от своих обязанностей.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Не надо мне рассказывать, старик.
      </p>
      <p>МОЛОДОЙ открывает ЖУРНАЛ. Он читает вслух:</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        <i>Помощник спал допоздна. Работает<br/>
          вполсилы.</i>
      </p><p>Переворачивает страницу.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        <i>Настроен Враждебно</i>
      </p>
      <p style={{ textAlign: "right" }}>86.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page85" />
        <ForwardLink href="/page87" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710717920/the-lighthouse-script/ouw5ctmzy9gzbn02ughb.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page87;
